import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { clientLogger } from './services/clientLogger';

// Initialize frontend error interception (window.onerror & unhandledrejections)
clientLogger.init();
// Handle Vite dynamic chunk preload errors (e.g. stale deployment or network hiccup on iOS Safari)
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event: any) => {
    console.warn('⚠️ [Vite] Dynamic import preload error detected. Auto-reloading to fetch fresh bundle...', event);

    clientLogger.captureError({
      type: 'VITE_PRELOAD_ERROR',
      level: 'warn',
      message: `Сбой динамической предзагрузки модуля Vite: ${event?.payload?.message || String(event?.payload || 'Preload Failure')}`,
      metadata: {
        payload: event?.payload?.message || String(event?.payload || ''),
        url: window.location.href,
      },
    });
    clientLogger.flushImmediately();

    const lastPreloadReload = sessionStorage.getItem('last_vite_preload_reload');
    const now = Date.now();
    if (!lastPreloadReload || now - parseInt(lastPreloadReload, 10) > 10000) {
      sessionStorage.setItem('last_vite_preload_reload', now.toString());
      window.location.reload();
    }
  });
}


import './index.css';

// Safe alert polyfill for sandboxed iframes
if (typeof window !== "undefined") {
  window.alert = function (message) {
    console.log("Alert:", message);
    
    const containerId = "custom-alert-container";
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement("div");
      container.id = containerId;
      container.style.position = "fixed";
      container.style.bottom = "20px";
      container.style.right = "20px";
      container.style.zIndex = "999999";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.gap = "10px";
      container.style.maxWidth = "350px";
      document.body.appendChild(container);
    }

    const alertDiv = document.createElement("div");
    alertDiv.style.background = "#1e293b";
    alertDiv.style.color = "#f8fafc";
    alertDiv.style.padding = "12px 16px";
    alertDiv.style.borderRadius = "12px";
    alertDiv.style.boxShadow = "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)";
    alertDiv.style.border = "1px solid #334155";
    alertDiv.style.fontFamily = "system-ui, -apple-system, sans-serif";
    alertDiv.style.fontSize = "13px";
    alertDiv.style.lineHeight = "1.5";
    alertDiv.style.display = "flex";
    alertDiv.style.alignItems = "start";
    alertDiv.style.gap = "10px";
    alertDiv.style.transition = "all 0.3s ease";
    alertDiv.style.opacity = "0";
    alertDiv.style.transform = "translateY(20px)";

    alertDiv.innerHTML = `
      <span style="color: #f59e0b; font-size: 16px; line-height: 1; user-select: none;">⚠️</span>
      <div style="flex-grow: 1; font-weight: 500;">${message}</div>
      <button style="background: none; border: none; color: #94a3b8; cursor: pointer; font-size: 14px; line-height: 1; padding: 0 0 0 5px;" onclick="this.parentElement.remove()">✕</button>
    `;

    container.appendChild(alertDiv);
    
    // Force reflow
    alertDiv.offsetHeight;
    
    // Animate in
    alertDiv.style.opacity = "1";
    alertDiv.style.transform = "translateY(0)";

    // Auto remove after 6 seconds
    setTimeout(() => {
      alertDiv.style.opacity = "0";
      alertDiv.style.transform = "translateY(-10px)";
      setTimeout(() => {
        alertDiv.remove();
        if (container && container.childNodes.length === 0) {
          container.remove();
        }
      }, 300);
    }, 6000);
  };
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
